<template>
  <div>
    <b-row>
      <b-col
        cols="12"
        md="8"
      >
        <b-card>
          <title-text />
          <qr-code-colors />
          <status-select />
          <page-link v-if="dataItem.id" />
          <b-button
            variant="primary"
            :disabled="dataItem.submitStatus"
            @click="submitForm"
          >
            Kaydet
          </b-button>
        </b-card>
      </b-col>
      <b-col
        cols="12"
        md="4"
      >
        <b-card>
          <b-img
            v-if="preview"
            :src="preview"
            fluid
            thumbnail
          />
          <div v-else>
            <blank-preview />
          </div>
          <b-button
            class="mt-1"
            variant="primary"
            block
            @click="getPreview"
          >
            <FeatherIcon icon="EyeIcon" />
            Önizleme
          </b-button>
          <b-button
            variant="success"
            :disabled="downloadLink === null"
            block
            :href="downloadLink"
            target="_blank"
          >
            <FeatherIcon icon="DownloadIcon" />
            İndir
          </b-button>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import {
  BCard, BRow, BCol, BButton, BImg,
} from 'bootstrap-vue'
import TitleText from '@/views/QrCodes/elements/TitleText.vue'
import StatusSelect from '@/views/QrCodes/elements/StatusSelect.vue'
import QrCodeColors from '@/views/QrCodes/elements/QrCodeColors.vue'
import BlankPreview from '@/views/QrCodes/elements/BlankPreview.vue'
import PageLink from '@/views/QrCodes/elements/PageLink.vue'

export default {
  name: 'QrCodesItemForm',
  components: {
    BCard,
    BButton,
    BRow,
    BCol,
    BImg,
    TitleText,
    StatusSelect,
    QrCodeColors,
    BlankPreview,
    PageLink,
  },
  props: {
    submitForm: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      mediaType: 'image',
      downloadToken: localStorage.getItem('downloadToken'),
      cropperSettings: {
        modalStatus: false,
        fileName: null,
        folder: null,
        ratio: null,
        type: null,
      },
    }
  },
  computed: {
    downloadLink() {
      let url = null
      if (this.dataItem.code) {
        url = `${this.$store.state.app.baseURL}Exports/qrcodes?code=${this.dataItem.code}&token=${this.downloadToken}`
      }
      return url
    },
    dataItem() {
      return this.$store.getters['qrcodes/dataItem']
    },
    preview() {
      const svgContent = this.$store.getters['qrcodes/preview']
      if (svgContent) {
        const base64Svg = btoa(svgContent)
        return `data:image/svg+xml;base64,${base64Svg}`
      }
      return null
    },
  },
  methods: {
    getPreview() {
      this.$store.dispatch('qrcodes/getPreview', {
        url: null,
        id_qrcode_colors: this.dataItem.id_qrcode_colors,
      })
    },
  },
}
</script>
